<template>
  <div class="popup-body">
    <div ref="stickySentinel" class="sentinel"></div>
    <div class="terms-privacy">
      <div class="terms-privacy-list" :class="{'is-sticky': isSticky, 'is-expanded': isExpanded}">
        <ul>
          <li><NuxtLink to="#tp-spec1-1" @click="resetBeforeMove">제 1 조  목적</NuxtLink></li>
          <li>
            <NuxtLink to="#tp-spec1-2" @click="resetBeforeMove">제 2 조  정의</NuxtLink>
          </li>
          <li>
            <NuxtLink to="#tp-spec1-3" @click="resetBeforeMove">제 3 조  약관의 명시&middot;교부&middot;설명 및 변경</NuxtLink>
          </li>
          <li>
            <NuxtLink to="#tp-spec1-4" @click="resetBeforeMove">제 4 조  전자금융거래서비스의 구성 및 내용, 변경</NuxtLink>
          </li>
          <li>
            <NuxtLink to="#tp-spec1-5" @click="resetBeforeMove">제 5 조  전자금융거래계약의 체결</NuxtLink>
          </li>
          <li>
            <NuxtLink to="#tp-spec1-6" @click="resetBeforeMove">제 6 조  이용시간 등</NuxtLink>
          </li>
          <li>
            <NuxtLink to="#tp-spec1-7" @click="resetBeforeMove">제 7 조  거래내용의 확인 및 보존</NuxtLink>
          </li>
          <li>
            <NuxtLink to="#tp-spec1-8" @click="resetBeforeMove">제 8 조  오류의 정정</NuxtLink>
          </li>
          <li>
            <NuxtLink to="#tp-spec1-9" @click="resetBeforeMove">제 9 조  회사의 책임</NuxtLink>
          </li>
          <li>
            <NuxtLink to="#tp-spec1-10" @click="resetBeforeMove">제 10 조  전자금융거래 장애 시의 처리</NuxtLink>
          </li>
          <li>
            <NuxtLink to="#tp-spec1-11" @click="resetBeforeMove">제 11 조  전자지급거래의 효력발생 시기 및 거래지시의 철회</NuxtLink>
          </li>
          <li>
            <NuxtLink to="#tp-spec1-12" @click="resetBeforeMove">제 12 조  접근매체의 선정과 사용 및 관리</NuxtLink>
          </li>
          <li>
            <NuxtLink to="#tp-spec1-13" @click="resetBeforeMove">제 13 조  신고사항의 변경 및 사고신고</NuxtLink>
          </li>
          <li>
            <NuxtLink to="#tp-spec1-14" @click="resetBeforeMove">제 14 조  안전성 확보 의무</NuxtLink>
          </li>
          <li>
            <NuxtLink to="#tp-spec1-15" @click="resetBeforeMove">제 15 조  환급 등</NuxtLink>
          </li>
          <li>
            <NuxtLink to="#tp-spec1-16" @click="resetBeforeMove">제 16 조  선불전자지급수단의 소멸시효 및 유효기간</NuxtLink>
          </li>
          <li>
            <NuxtLink to="#tp-spec1-17" @click="resetBeforeMove">제 17 조  선불충전금의 보호 및 지급</NuxtLink>
          </li>
          <li>
            <NuxtLink to="#tp-spec1-18" @click="resetBeforeMove">제 18조  선불충전금 보호조치의 고지 및 게시</NuxtLink>
          </li>
          <li>
            <NuxtLink to="#tp-spec1-19" @click="resetBeforeMove">제 19조  이용자 정보에 대한 비밀보장</NuxtLink>
          </li>
          <li>
            <NuxtLink to="#tp-spec1-20" @click="resetBeforeMove">제 20조  분쟁처리 및 분쟁조정</NuxtLink>
          </li>
          <li>
            <NuxtLink to="#tp-spec1-21" @click="resetBeforeMove">제 21조  약관적용의 우선순위 등</NuxtLink>
          </li>
          <li>
            <NuxtLink to="#tp-spec1-22" @click="resetBeforeMove">제 22조  거래의 제한</NuxtLink>
          </li>
          <li>
            <NuxtLink to="#tp-spec1-23" @click="resetBeforeMove">제 23조  준거법 등</NuxtLink>
          </li>
        </ul>
        <button type="button" v-if="isSticky && !isExpanded" class="more-badge" @click="isExpanded = !isExpanded"></button>
      </div>
      <div class="terms-privacy-cont">
        <p class="tp-tit02" id="tp-spec1-1">제 1 조 (목적)</p>
        <div class="tp-cont">
          <p class="tp-cont-txt">본 약관은 주식회사 현대이지웰(이하 "회사"라 합니다)이 제공하는 전자금융거래에 대한 기본적인 사항을 정함으로써 전자금융거래를 이용하고자 하는 이용자와 회사 간의 권리&middot;의무 관계를 명확하게 규정하는 것을 목적으로 합니다.</p>
        </div>
        <p class="tp-tit02" id="tp-spec1-2">제 2 조 (정의)</p>
        <div class="tp-cont">
          <p class="tp-cont-txt">본 약관에서 사용하는 용어의 정의는 다음과 같습니다.</p>
          <ol class="ol-list">
            <li>①	"전자금융거래"란 회사가 전자적 장치를 통하여 금융상품 및 서비스를 제공하고 이용자가 회사와 직접 대면하거나 의사소통을 하지 아니하고 자동화된 방식으로 이를 이용하는 거래를 말합니다.</li>
            <li>②	"이용자"란 전자금융거래를 위하여 회사와 체결한 계약(이하 "전자금융거래계약"이라 합니다)에 따라 전자금융거래를 이용하는 자로서 본 약관에 동의한 개인을 말합니다.</li>
            <li>③	"고객사"란 소속 임직원이 자신의 선호와 필요에 따라 자율적으로 복지항목을 선택하여 복지혜택을 받는 제도(이하 "선택적 복지제도"라 합니다)를 운영하는 자로 회사와 선택적 복지제도 위탁 운영 계약을 체결하고 선택적 복지제도 운영을 위탁한 법인 또는 단체로 본 항 ②호의 "이용자" 외의 자를 말합니다.</li>
            <li>④	"구매자"란 회사와 신유형 상품권 공급에 관한 계약을 체결하여 본인 또는 제3자에게 제공할 목적으로 신유형 상품권에 대한 대가를 회사에 미리 지급한 자로 본 항 ②호의 "이용자" 외의 자를 말합니다.</li>
            <li>⑤	"전자적 장치"란 전자금융거래정보를 전자적 방법으로 전송하거나 처리하는 데 이용되는 장치로서 현금자동지급기, 자동입출금기, 지급용단말기, 컴퓨터, 전화기 그 밖에 전자적 방법으로 정보를 전송하거나 처리하는 장치를 말합니다.</li>
            <li>⑥	"전자문서"란 「전자문서 및 전자거래기본법」 제2조 제1호에 따라 작성, 송신&middot;수신 또는 저장된 정보를 말합니다.</li>
            <li>⑦	"접근매체"란 전자금융거래에 있어서 이용자가 거래지시를 하거나 또는 이용자 및 거래내용의 진실성과 정확성을 확보하기 위하여 사용되는 다음 각 목의 어느 하나에 해당하는 수단 또는 정보를 말합니다.
              <ol class="ol-list pl11">
                <li>1. 전자식 카드 및 이에 준하는 전자적 정보</li>
                <li>2.「전자서명법」 제2조 제3호의 전자서명생성정보 및 같은 조 제6호의 인증서</li>
                <li>3. 회사에 등록된 이용자번호</li>
                <li>4. 이용자의 생체정보</li>
                <li>5. 1호 또는 2호의 수단이나 정보를 사용하는 데 필요한 비밀번호</li>
              </ol>
            </li>
            <li>⑧	"선불전자지급수단"이란 이전 가능한 금전적 가치가 전자적 방법으로 저장되어 발행된 증표로서 발행인 외의 제3자로부터 재화 또는 용역을 구입하고 그 대가를 지급하는 데 사용되는 것으로 회사가 발행하는 신유형 상품권 등 이용자가 대가를 지급하여 구매(충전)한 선불전자지급수단(이하 “유상 선불전자지급수단”)과 고객사와의 선택적 복지제도 위탁운영 계약에 따라 이용자에게 부여되는 복지포인트 등 이용자가 대가를 지급하지 아니한 선불전자지급수단(이하 “무상 선불전자지급수단”) 을 말합니다.</li>
            <li>⑨	"신유형 상품권"이란 그 명칭에 관계없이 회사가 일정한 금액이나 물품 또는 용역의 수량(이하 '금액 등'이라 함)이 전자적 방법으로 저장되어 있거나, 전자정보가 기록되어 있다는 것이 기재된 증표를 다음 각 호의 형태로 발행하고 이용자가 이를 제시 또는 교부하거나 기타의 방법으로 사용함으로써 그 증표에 기재된 내용에 따라 재화 또는 용역을 제공받을 수 있는 것으로 다음 각호의 상품권을 말합니다.
              <ol class="ol-list pl11">
                <li>1. 금액형 신유형 상품권: 비정액(수시로 충전할 수 있는 형태를 뜻함. 이하 '충전형'이라 함) 또는 정액형 선불전자지급수단으로 유효기간 내에 잔액 범위 내에서 사용횟수에 제한 없이 자유롭게 상품 등을 제공받을 수 있는 신유형 상품권</li>
                <li>2. 물품 및 용역 제공형 신유형 상품권: 한정된 재화 또는 용역 제공을 목적으로 발행된 신유형 상품권</li>
              </ol>
            </li>
            <li>⑩	"선불충전금"이란 이용자 또는 고객사가 선불전자지급수단 발행의 대가로 회사에 선지급한 금액으로서 대금결제, 양도, 환급 등에 사용한 금액을 차감한 잔액을 말합니다.</li>
            <li>⑪	"선불충전금관리기관"이란 「전자금융거래법 시행령」 제13조의2 제3항에서 정하는 금융회사로 회사가 지정한 금융회사를 말합니다.</li>
            <li>⑫	"거래지시"란 이용자가 전자금융거래계약에 따라 회사에 전자금융거래의 처리를 지시하는 것을 말합니다.</li>
            <li>⑬	"오류"란 이용자의 고의 또는 과실 없이 전자금융거래가 본 약관, 전자금융거래계약 또는 이용자의 거래지시에 따라 이행되지 아니한 경우를 말합니다.</li>
            <li>⑭	"제휴사"란 회사와의 계약에 따라 선불전자지급수단에 의한 거래에 있어서 이용자에게 재화 또는 용역을 제공하는 자를 말하며, 「전자금융거래법」상 가맹점에 해당합니다.</li>
            <li>⑮	 "개별약관"이란 본 약관과 함께 전자금융거래에 적용되는 약관으로서 회사가 별도로 작성한 약관을 말합니다.</li>
          </ol>
          <p class="tp-cont-txt">본 약관에서 별도로 정하지 아니한 용어의 정의는 「전자금융거래법」 및 「전자금융거래법 시행령」, 금융위원회의 「전자금융감독규정」 및 「전자금융감독규정 시행세칙」 등 관계 법령에서 정하는 바에 따릅니다.</p>
        </div>
        <p class="tp-tit02" id="tp-spec1-3">제 3 조 (약관의 명시&middot;교부&middot;설명 및 변경)</p>
        <div class="tp-cont">
          <ol class="ol-list">
            <li>①	회사는 이용자가 약관의 내용에 대한 설명을 요청하는 경우 다음 각 호의 어느 하나의 방법으로 이용자에게 약관의 중요내용을 설명하여야 합니다.
              <ol class="ol-list pl11">
                <li>1. 약관의 중요내용을 이용자에게 직접 설명</li>
                <li>2. 약관의 중요내용에 대한 설명을 전자적 장치를 통하여 이용자가 알기 쉽게 표시하고, 이용자로부터 해당 내용을 충분히 인지하였다는 의사표시를 전자적 장치를 통하여 수령</li>
              </ol>
            </li>
            <li>②	회사는 이용자에게 약관을 명시하여야 하고, 이용자의 요청이 있는 경우 전자문서 전송, 전자우편, 모사전송, 우편 또는 직접 교부의 방식(이하 "전자문서 전송 등의 방식"이라 합니다)으로 본 약관의 사본을 이용자에게 교부합니다.</li>
            <li>③	회사가 본 약관을 변경하는 때에는 그 시행일 1개월 전에 변경되는 약관을 회사가 제공하는 전자금융거래서비스 이용 초기화면 또는 초기화면에서 연결되는 페이지(이하 총칭하여 "초기화면"이라 합니다)에 게시하고 이용자에게 서면, 전자우편, 문자메시지, 앱 푸시알림 중 사전에 이용자와 합의한 방법으로 개별 통지하여야 하며, 합의한 방법이 없는 경우에는 전자금융거래법이 허용하는 방법(서면, 전자우편, 전자적 장치 화면 게시 등) 중 하나 이상의 방법으로 이용자에게 개별 통지합니다. 다만, 이용자가 이의를 제기할 경우 회사는 이용자에게 적절한 방법으로 약관 변경내용을 통지하였음을 확인해 주어야 합니다.</li>
            <li>④	전항에도 불구하고 법령의 개정으로 인하여 긴급하게 약관을 변경한 때에는 변경된 약관을 초기화면 및 전자적 장치에 최소 1개월 이상 게시하고 이용자에게 통지하여야 합니다.</li>
            <li>⑤	회사가 제3항 및 제4항에 따라 변경된 약관을 게시하거나 통지하는 경우에는 "이용자가 약관의 변경내용이 게시되거나 통지된 후로부터 변경되는 약관의 시행일 전의 영업일까지 계약을 해지할 수 있으며, 약관의 시행일까지 약관의 변경내용에 이의를 제기하지 아니하는 경우 약관의 변경내용에 승인한 것으로 본다"라는 취지의 내용을 통지하여야 합니다.</li>
            <li>⑥	이용자는 약관의 변경내용이 게시되거나 통지된 후부터 변경되는 약관의 시행일 전의 영업일까지 전자금융거래의 계약을 해지할 수 있고, 회사가 제5항에 따라 약관의 변경을 통지하였음에도 약관의 변경내용에 대하여 약관의 시행일까지 이의를 제기하지 아니하는 경우에는 약관의 변경을 승인한 것으로 봅니다.</li>
          </ol>
        </div>
        <p class="tp-tit02" id="tp-spec1-4">제 4 조 (전자금융거래서비스의 구성 및 내용, 변경)</p>
        <div class="tp-cont">
          <ol class="ol-list">
            <li>①	회사가 제공하는 전자금융거래서비스는 다음 각 호와 같습니다.
              <ol class="ol-list pl11">
                <li>1. 선불전자지급수단의 발행 및 관리 서비스</li>
              </ol>
            </li>
            <li>②	회사는 전자금융거래서비스를 추가하거나 변경하고자 하는 경우에는 이용자에게 그 내용을 사전 고지하고 해당 전자금융거래서비스를 추가하거나 변경할 수 있습니다.</li>
            <li>③	제2항에 따라 전자금융거래서비스의 내용, 이용방법, 이용시간에 대하여 변경이 있는 경우 회사는 변경사유, 변경될 서비스의 내용 및 제공일자 등을 그 변경 1개월 전에 전자적 장치에 게시하여야 합니다. 이 때 약관의 개정이 필요한 경우 회사는 제3조에 따라 약관을 함께 개정합니다.</li>
          </ol>
        </div>
        <p class="tp-tit02" id="tp-spec1-5">제 5 조 (전자금융거래계약의 체결)</p>
        <div class="tp-cont">
          <ol class="ol-list">
            <li>①	전자금융거래를 이용하고자 하는 이용자는 본 약관에서 정하는 방법에 따라 회사와 전자금융거래계약을 체결하여야 합니다.</li>
            <li>②	회사는 제1항에 따른 전자금융거래계약을 체결함에 있어 이용자에게 약관의 내용을 분명하게 밝혀야 하며, 이용자의 요청이 있는 경우 다음 각 호의 어느 하나에 해당하는 방법으로 이용자에게 약관을 내주어야 합니다.
              <ol class="ol-list pl11">
                <li>1. 직접교부</li>
                <li>2. 전자문서의 전송(전자우편을 이용한 전송을 포함합니다)</li>
                <li>3. 팩스(FAX)</li>
                <li>4. 우편</li>
              </ol>
            </li>
            <li>③	회사는 제1항에 따른 전자금융거래계약을 체결함에 있어 이용자가 약관의 내용에 대한 설명을 요청하는 경우 다음 각 호의 어느 하나에 해당하는 방법으로 이용자에게 약관의 중요내용을 설명하여야 합니다.
              <ol class="ol-list pl11">
                <li>1. 약관의 중요내용을 이용자에게 직접 설명</li>
                <li>2. 약관의 중요내용에 대한 설명을 전자적 장치를 통하여 이용자가 알기 쉽게 표시하고 이용자로부터 해당 내용을 충분히 알았다는 의사표시를 전자적 장치를 통하여 수령</li>
              </ol>
            </li>
            <li>④	이용자는 본 약관에서 정하는 방법에 따라 전자금융거래계약을 해지할 수 있습니다.</li>
          </ol>
        </div>
        <p class="tp-tit02" id="tp-spec1-6">제 6 조 (이용시간 등)</p>
        <div class="tp-cont">
          <ol class="ol-list">
            <li>①	이용자는 연중무휴 1일 24시간 전자금융거래를 이용할 수 있습니다.</li>
            <li>②	회사는 제1항에 따른 이용시간을 전자적 장치에 게시하며, 이를 변경하고자 하는 경우 이용자가 확인할 수 있도록 변경 예정일 30일 전부터 마련해 두고, 전자적 장치를 통해 게시합니다. 다만, 시스템 장애복구, 프로그램의 긴급한 보수, 외부요인 등으로 인하여 이용시간이 불가피하게 변경된 경우에는 이를 미리 전자적 장치를 통해 게시하지 아니할 수 있으며, 이 경우 신속히 사후통지합니다.</li>
            <li>③	전산시스템 유지 및 보수로 인하여 전자금융거래 이용이 불가능할 경우, 회사는 해당사실을 7일 전에 전자적 장치에 게시합니다.</li>
          </ol>
        </div>
        <p class="tp-tit02" id="tp-spec1-7">제 7 조 (거래내용의 확인 및 보존)</p>
        <div class="tp-cont">
          <ol class="ol-list">
            <li>①	회사는 이용자가 전자금융거래에 사용하는 전자적 장치(회사와 이용자 사이에 미리 약정한 전자적 장치가 있는 경우에는 그 전자적 장치를 포함합니다)를 통하여 거래내용을 확인할 수 있도록 합니다.</li>
            <li>②	제1항의 경우, 전자적 장치의 운영 장애, 그 밖의 사유로 거래내용을 확인할 수 없는 경우에 회사는 인터넷 등을 이용하여 즉시 그 사유를 알리고, 그 사유가 종료된 때부터 이용자가 거래내용을 확인할 수 있도록 합니다.</li>
            <li>③	이용자는 거래지시와 제1항에 따른 거래내용이 일치하는지 여부를 확인하여야 합니다.</li>
            <li>④	이용자는 거래내용을 서면(본 항에서는 전자문서를 제외합니다. 이하 이 조에서 같습니다)으로 제공하여 줄 것을 회사에 요청할 수 있으며, 회사는 그 요청을 받은 날로부터 2주 이내에 거래내용에 관한 서면을 교부합니다.</li>
            <li>⑤	회사는 전자적 장치의 운영 장애, 그 밖의 사유로 거래내용을 제공할 수 없는 때에는 그 이용자에게 즉시 이를 알려야 하며, 이 경우 거래내용에 관한 서면의 교부기간을 산정함에 있어서 전자적 장치의 운영 장애, 그 밖에 사유로 거래내용을 제공할 수 없는 기간은 이를 포함하지 않습니다.</li>
            <li>⑥	회사가 제1항 및 제4항에 따라 제공하는 거래내용의 종류(조회거래는 제외합니다), 범위 및 대상 기간이 5년인 것은 다음 각 호와 같습니다.
              <ol class="ol-list pl11">
                <li>1. 전자금융거래가 계좌를 통하여 이루어지는 경우 거래계좌의 명칭 또는 번호</li>
                <li>2. 전자금융거래의 종류 및 금액</li>
                <li>3. 전자금융거래 상대방을 나타내는 정보</li>
                <li>4. 전자금융거래일시</li>
                <li>5. 전자적 장치의 종류 및 전자적 장치를 식별할 수 있는 정보</li>
                <li>6. 회사가 전자금융거래의 대가로 받은 수수료</li>
                <li>7. 이용자의 출금 동의에 관한 사항</li>
                <li>8. 해당 전자금융거래와 관련한 전자적 장치의 접속기록</li>
                <li>9. 전자금융거래의 신청 및 조건의 변경에 관한 사항</li>
                <li>10. 건당 거래금액이 1만원을 초과하는 전자금융거래에 관한 기록</li>
              </ol>
            </li>
            <li>⑦	회사가 제1항 및 제4항에 따라 제공하는 거래내용의 종류, 범위 및 대상 기간이 1년인 것은 다음 각 호와 같습니다.
              <ol class="ol-list pl11">
                <li>1. 건당 거래금액이 1만원 이하인 소액 전자금융거래에 관한 기록</li>
                <li>2. 전자지급수단 이용과 관련된 거래승인에 관한 기록</li>
                <li>3. 이용자의 전자금융거래에 대한 오류정정 요구사실 및 처리결과에 관한 사항</li>
                <li>4. 기타 금융위원회가 고시로 정한 사항</li>
              </ol>
            </li>
            <li>⑧	이용자가 제4항에서 정한 서면교부를 요청하고자 할 경우, 다음의 주소, 전자우편주소 및 전화번호로 우편, 메일, 유선, 온라인으로 요청할 수 있습니다.
              <ul class="tp-cont-ul">
                <li>- 주소 : 서울특별시 서대문구 충정로 23, 8층 일부, 9, 10층(충정로3가, 풍산빌딩)</li>
                <li>- 이메일 주소 : hcon@hyundaiezwel.com</li>
                <li>- 전화번호 : 02-2161-0880 (평일 : 9시 ~ 18시)</li>
              </ul>
            </li>
          </ol>
        </div>
        <p class="tp-tit02" id="tp-spec1-8">제 8 조 (오류의 정정)</p>
        <div class="tp-cont">
          <ol class="ol-list">
            <li>①	이용자는 전자금융거래에 오류가 있음을 안 때에는 회사에게 이에 대한 정정을 요구할 수 있습니다.</li>
            <li>②	회사는 제1항에 따른 오류의 정정요구를 받은 때에는 이를 즉시 조사하여 처리하며 정정요구를 받은 날부터 2주 이내에 오류의 원인과 처리 결과를 문서, 전화 또는 전자우편으로 이용자에게 알려야 합니다. 다만, 이용자가 문서(본 조에서 전자문서를 제외합니다)로 알려줄 것을 요청하는 경우에는 문서로 알려야 합니다.</li>
            <li>③	회사가 스스로 전자금융거래에 오류가 있음을 안 때에는 이를 즉시 조사하여 처리하며, 오류가 있음을 안 날로부터 2주 이내에 오류의 원인과 처리 결과를 문서, 전화 또는 전자우편으로 이용자에게 알려야 합니다. 다만 이용자가 문서로 알려줄 것을 요청하는 경우에는 문서로 알려야 합니다.</li>
          </ol>
        </div>
        <p class="tp-tit02" id="tp-spec1-9">제 9 조 (회사의 책임)</p>
        <div class="tp-cont">
          <ol class="ol-list">
            <li>①	회사는 다음 각 호의 어느 하나에 해당하는 사고로 인하여 이용자에게 손해가 발생한 경우에는 그 손해를 배상할 책임을 집니다.
              <ol class="ol-list pl11">
                <li>1. 접근매체의 위조나 변조로 발생한 사고</li>
                <li>2. 계약체결 또는 거래지시의 전자적 전송이나 처리 과정에서 발생한 사고</li>
                <li>3. 전자금융거래를 위한 전자적 장치 또는 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」 제2조 제1항 제1호에 따른 정보통신망에 침입(해킹 등)하여 거짓이나 그 밖의 부정한 방법으로 획득한 접근매체의 이용으로 발생한 사고</li>
              </ol>
            </li>
            <li>②	제1항에도 불구하고 회사는 이용자의 고의 또는 중대한 과실이 있는 경우로서 다음 각 호의 어느 하나에 해당하는 경우에는 그 책임의 전부 또는 일부를 이용자가 부담하게 할 수 있습니다.
              <ol class="ol-list pl11">
                <li>1. 이용자가 접근매체를 제3자에게 대여하거나 사용을 위임하거나 양도 또는 담보 목적으로 제공한 경우(「전자금융거래법」 제18조에 따라 선불전자지급수단을 양도하거나 담보로 제공한 경우를 제외합니다)</li>
                <li>2. 제3자가 권한 없이 이용자의 접근매체를 이용하여 전자금융거래를 할 수 있음을 알았거나 쉽게 알 수 있었음에도 불구하고 이용자가 자신의 접근매체를 누설 또는 노출하거나 방치한 경우</li>
                <li>3. 회사가 「전자금융거래법」 제7조 제1항에 따른 확인 외에 보안강화를 위하여 전자금융거래 시 요구하는 추가적인 보안조치를 이용자가 정당한 사유 없이 거부하여 「전자금융거래법」 제9조 제1항 제3호의 사고가 발생한 경우</li>
                <li>4. 이용자가 제3호에 따른 추가적인 보안조치에 사용되는 매체&middot;수단 또는 정보에 대하여 다음 각 목의 어느 하나에 해당하는 행위를 하여 「전자금융거래법」 제9조 제1항 제3호에 따른 사고가 발생한 경우
                  <ol class="ol-list pl11">
                    <li>가.	누설&middot;노출 또는 방치한 행위</li>
                    <li>나.	제3자에게 대여하거나 그 사용을 위임한 행위 또는 양도나 담보의 목적으로 제공한 행위</li>
                  </ol>
                </li>
                <li>5. 법인(「중소기업기본법」 제2조 제2항에 의한 소기업을 제외합니다)인 이용자에게 손해가 발생한 경우로 회사가 사고를 방지하기 위하여 보안절차를 수립하고 이를 철저히 준수하는 등 합리적으로 요구되는 주의의무를 다한 경우
                </li>
              </ol>
            </li>
            <li>③	회사는 이용자로부터 접근매체의 분실이나 도난 등의 통지를 받은 때에는 그때부터 제3자가 그 접근매체를 사용하여 이용자에게 발생한 손해를 배상합니다.</li>
            <li>④	회사는 제1항부터 제3항에도 불구하고 다른 법령에 이용자에게 유리하게 적용될 수 있는 규정이 있는 경우, 그 법령을 우선 적용합니다.</li>
          </ol>
        </div>
        <p class="tp-tit02" id="tp-spec1-10">제 10 조 (전자금융거래 장애 시의 처리)</p>
        <div class="tp-cont">
          <p class="tp-cont-txt">회사는 천재지변, 정전, 화재, 건물훼손, 전산장애 등의 사유로 이용자의 거래지시를 처리할 수 없거나 처리가 지연될 경우, 해당 사실과 사유 등을 이용자에게 지체 없이 통보하며, 정상적인 전자금융거래가 이루어질 수 있도록 신속하게 조치합니다.</p>          
        </div>
        <p class="tp-tit02" id="tp-spec1-11">제 11 조 (전자지급거래의 효력발생 시기 및 거래지시의 철회)</p>
        <div class="tp-cont">
          <ol class="ol-list">
            <li>①	전자지급수단을 이용하여 자금을 지급하는 경우, 지급의 효력은 다음 각 호에서 정한 때에 발생합니다.
              <ol class="ol-list pl11">
                <li>1. 선불전자지급수단으로 지급된 경우에는 거래지시된 금액의 정보가 수취인이 지정한 전자적 장치에 도달한 때</li>
              </ol>
            </li>
            <li>②	이용자는 지급의 효력이 발생하기 전까지 거래지시를 철회할 수 있습니다.</li>
          </ol>
        </div>
        <p class="tp-tit02" id="tp-spec1-12">제 12 조 (접근매체의 선정과 사용 및 관리)</p>
        <div class="tp-cont">
          <ol class="ol-list">
            <li>①	회사는 전자금융거래의 종류&middot;성격&middot;위험수준 등을 고려하여 안전한 인증방법으로서 접근매체를 선정 및 사용, 관리하여야 하며, 이를 통하여 이용자의 신원, 권한 및 거래지시의 내용 등을 확인합니다.</li>
            <li>②	이용자는 접근매체를 사용 및 관리함에 있어서 다른 법률에 특별한 규정이 없는 한 다음 각 호의 행위를 하여서는 아니 됩니다. 다만, 「전자금융거래법」 제18조의 선불전자지급수단의 양도 또는 담보제공을 위하여 필요한 경우에는 그러하지 아니합니다.
              <ol class="ol-list pl11">
                <li>1. 접근매체를 양도하거나 양수하는 행위</li>
                <li>2. 대가를 수수(授受)&middot;요구 또는 약속하면서 접근매체를 대여받거나 대여하는 행위 또는 보관&middot;전달&middot;유통하는 행위</li>
                <li>3. 범죄에 이용할 목적으로 또는 범죄에 이용될 것을 알면서 접근매체를 대여받거나 대여하는 행위 또는 보관&middot;전달&middot;유통하는 행위</li>
                <li>4. 접근매체를 질권의 목적으로 하는 행위</li>
                <li>5. 제1호부터 제4호까지의 행위를 알선&middot;중개&middot;광고하거나 대가를 수수&middot;요구 또는 약속하면서 권유하는 행위</li>
              </ol>
            </li>
            <li>③	이용자는 접근매체를 제3자에게 누설하여서는 아니 되며, 접근매체의 분실, 도용, 위조 또는 변조를 방지하기 위하여 그 관리에 충분한 주의를 기울여야 합니다.</li>
            <li>④	회사는 이용자로부터 접근매체의 분실이나 도난 등의 통지를 받은 때에는 그 때부터 제3자가 그 접근매체를 사용함으로 인하여 이용자에게 발생한 손해를 배상할 책임이 있습니다.</li>
          </ol>
        </div>
        <p class="tp-tit02" id="tp-spec1-13">제 13 조 (신고사항의 변경 및 사고신고)</p>
        <div class="tp-cont">
          <ol class="ol-list">
            <li>①	이용자가 주소(전자우편 주소를 포함합니다), 전화번호, 각종 비밀번호 등 회사에 신고한 사항을 변경하고자 하는 경우, 본 약관 제7조 제8항을 통해 회사에 신고하여야 합니다.</li>
            <li>②	이용자는 접근매체의 도난, 분실, 위조 또는 변조 등 기타 전자금융거래에 있어 비밀을 요하는 사항이 도난, 분실, 위조, 변조 또는 누설되었음을 알았을 때에는 지체 없이 이를 회사에 신고하여야 합니다.</li>
          </ol>
        </div>
        <p class="tp-tit02" id="tp-spec1-14">제 14 조 (안전성 확보 의무)</p>
        <div class="tp-cont">
          <p class="tp-cont-txt">회사는 전자금융거래가 안전하게 처리될 수 있도록 선량한 관리자로서의 주의를 다하며, 전자금융거래의 안전성과 신뢰성을 확보할 수 있도록 전자금융거래의 종류별로 전자적 전송이나 처리를 위한 인력, 시설, 전자적 장치 등의 정보기술부문 및 전자금융업무에 관하여 금융위원회가 정하는 기준을 준수합니다.</p>
        </div>
        <p class="tp-tit02" id="tp-spec1-15">제 15 조 (환급 등)</p>
        <div class="tp-cont">
          <ol class="ol-list">
            <li>①	고객사의 선택적 복지제도 시행에 따라 이용자에게 제공되는 복지포인트 중 고객사와 회사간 사전 약정을 통해 복지포인트 대금을 회사에 선수금으로 지급한 경우에 고객사 정책에 따라 미사용 선수금 잔액을 고객사에 환급합니다. 단, 회사가 이용자에게 복지포인트를 선부여하고 이용자가 복지포인트 사용한 금액에 대해 고객사에 후불 정산하는 후불정산형 복지포인트의 경우 고객사 정책에 따라 환급대상에서 제외됩니다.</li>
            <li>②	이용자는 `이용자가 대가를 지급하여 구매(충전)한 선불전자지급수단에 관하여는 구매일(충전일)로부터 7일 이내에 구매액(충전액) 전부를 환불 받을 수 있습니다.</li>
            <li>③	회사가 발행하여 이용자가 대가를 지급하고 구매(충전)한 선불전자지급수단 중 유효기간 경과 전 금액형 신유형 상품권의 경우, 신유형 상품권 금액(다수의 상품권을 동시에 사용하는 경우에는 총 금액, 충전형 상품권의 경우 고객의 최종 충전시점에 기재된 금액)의 100분의 60(1만원 이하 신유형 상품권은 100분의 80)이상에 해당하는 물품 등을 제공받은 이용자가 잔액의 반환을 요구하는 경우, 회사는 잔액(구매액을 기준으로 사용비율에 따라 계산하여 남은 비율의 금액)을 반환하여야 합니다.</li>
            <li>④	회사가 발행하여 이용자가 대가를 지급하고 구매(충전)한 신유형 상품권 중 유효기간 경과 전 금액형 신유형 상품권의 경우 다음 각 호의 어느 하나에 해당하는 경우 회사는 이용자의 요구에 따라 신유형 상품권 잔액의 전부를 반환하여야 합니다.
              <ol class="ol-list pl11">
                <li>1. 상품권의 금액 범위 내에서 상품 등의 제공이 불가능(천재지변 또는 상품권 자체의 결함으로 인하여 제공이 곤란한 경우를 포함)하거나 제공에 필요한 통상적인 기간보다 현저히 지체되는 경우</li>
                <li>2. 회사가 이용자에게 불리하게 신유형 상품권을 이용할 수 있는 사용처를 축소하거나 그 이용조건을 변경하는 경우(다만, 가맹점 폐업, 가맹계약 기간의 만료와 같이 전자금융거래법 등 관계법령상 정당한 이유가 있는 경우는 제외)</li>
              </ol>
            </li>
            <li>⑤	회사가 발행하여 이용자가 대가를 지급하고 구매(충전)한 신유형 상품권 중 유효기간 경과 전 특정 물품 등의 제공형 신유형 상품권의 경우, 다음 각 호의 어느 하나에 해당하는 경우 고객의 요구에 따라 회사는 해당 신유형 상품권과 동일한 금전적 가치의 신유형 상품권으로 즉시 교환하거나 구매액을 반환하여야 합니다.
              <ol class="ol-list pl11">
                <li>1. 상품권 상의 물품 등의 제공이 불가능(천재지변 또는 상품권 자체의 결함으로 인하여 제공이 곤란한 경우를 포함)하거나 제공에 필요한 통상적인 기간보다 현저히 지체되는 경우</li>
                <li>2. 회사가 이용자에게 불리하게 신유형 상품권을 이용할 수 있는 사용처를 축소하거나 그 이용 조건을 변경하는 경우(다만, 가맹점 폐업, 가맹계약기간의 만료와 같이 「전자금융거래법」 등 관계법령상 정당한 이유가 있는 경우는 제외)</li>
              </ol>
            </li>
            <li>⑥	회사가 발행하여 이용자가 대가를 지급하고 구매(충전)한 유상 선불전자지급수단 중 유효기간이 경과한 후 소멸시효가 도래하지 않은 선불전자지급수단의 경우 구매(충전)일로부터 소멸시효 도래 전까지 이용자는 회사에게 미사용 부분에 대한 반환을 청구할 수 있으며, 회사는 다음 각호에 따라 잔액을 반환하여야 합니다.
              <ol class="ol-list pl11">
                <li>1. 5만원 이하의 유상 선불전자지급수단의 경우 90%</li>
                <li>2. 5만원 초과의 유상 선불전자지급수단의 경우 95%</li>
                <li>3. 적립금 환불의 경우 100%</li>
              </ol>
            </li>
            <li>⑦	회사가 구매자와 신유형 상품권 공급(유효기간 및 유효기간 연장에 관한 사항, 소멸시효 등)에 관한 약정을 체결하고 이용자에게 공급된 신유형 상품권의 환급등에 관한 조건은 회사와 구매자간 계약에서 정한 공급조건을 본 약관에 우선하여 적용합니다.</li>
            <li>⑧	회사는 선불전자지급수단의 환급 관련 기준 및 환급수수료 부과여부 및 부과기준 관련 구체적인 내용은 홈페이지 공지사항이나 앱의 공지사항 또는 별도 상세페이지 등을 통해 사전에 공지합니다. 다만, 신규로 수수료를 부과하거나 기존 수수료를 변경하게 되는 경우 시행 1개월 전에 홈페이지나 앱을 통해 공지하고 이용자에게 개별 통지합니다. 단, 이용자가 동의하지 않는 경우에는 서비스를 해지할 수 있습니다.</li>
            <li>⑨	 본 조에도 불구하고 다음 각 호의 어느 하나에 해당하는 경우 이용자는 회사에 선불전자지급수단의 환급을 요구할 수 있습니다.
              <ol class="ol-list pl11">
                <li>1. 천재지변 등의 사유로 제휴사(가맹점)가 재화 또는 용역을 제공하기 곤란하여 선불전자지급수단을 사용하지 못하게 된 경우</li>
                <li>2. 선불전자지급수단의 결함으로 제휴사(가맹점)가 재화 또는 용역을 제공하지 못하는 경우</li>
                <li>3. 선불전자지급수단의 구매 금액(최종 유상 충전 시, 그 시점의 잔액 기준)의 100분의 60(1만원 이하는 100분의 80 이상) 이상을 사용한 경우. 단, 선불전자지급수단을 할인 발행하며, 환불에 대한 정책을 별도로 정하였거나 이용자에게 무상 지급된 경우 개별 통지사항에 따릅니다.</li>
                <li>4. 이용자에게 불리하게 선불전자지급수단 이용 제휴사(가맹점)를 축소하거나 그 이용 조건을 변경하는 경우. 단, 제휴사(가맹점) 폐업, 제휴계약기간의 만료, 그 밖의 다음 각 목의 경우에는 그러하지 아니합니다.
                  <ol class="ol-list pl11">
                    <li>가.	「전자금융거래법」 제38조 제4항에 따라 제휴사(가맹점) 계약을 해지하는 경우</li>
                    <li>나.	제휴사(가맹점)가 「전자금융거래법」, 「전자상거래 등에서의 소비자보호 등에 관한 법률」, 그 밖에 이용자 보호 및 건전한 거래질서 유지와 관련되는 법령을 위반한 경우에는 제휴사(가맹점) 계약을 해지합니다"라는 내용이 포함된 약관에 따라 제휴사(가맹점) 계약을 해지하는 경우</li>
                    <li>다.	선불전자지급수단을 이용할 수 있는 제휴사(가맹점)를 축소하더라도 선불전자지급수단을 이용할 수 있는 다른 제휴사(가맹점)가 충분하여 제휴사(가맹점)가 제공하는 재화&middot;용역을 구입하려는 이용자의 이익을 저해할 우려가 없는 경우</li>
                    <li>라.	가목부터 다목까지에 준하는 경우로서 「전자금융감독규정」에서 정하는 정당한 이유가 있는 경우</li>
                  </ol>
                </li>
              </ol>
            </li>
            <li>⑩	본 약관에서 정한 바에 따라 제휴사(가맹점) 축소 또는 이용조건이 변경되는 경우 회사는 선불전자지급수단의 환급에 관한 내용을 회사의 인터넷 홈페이지 및 앱을 통해 제휴사(가맹점) 축소 또는 이용 조건이 변경되는 날로부터 30일 이상 게시합니다.</li>
            <li>⑪	회사가 발행하여 이용자가 대가를 지급하고 구매(충전)한 신유형 상품권의 환급을 요구할 수 있는 권리는 신유형 상품권의 최종 소지자가 가집니다. 다만, 최종 소지자가 환불을 요청할 수 없는 경우로 구매자가 회사와 사전 약정을 근거로 환급을 요청하는 경우 발행자는 구매자에게 환급함으로써 최종 소지자에 대한 환급 책임을 면합니다.</li>
            <li>⑫	이용자는 `회사에서 정한 기한 및 이용방법에 따라 선불전자지급수단을 이용할 수 있으며, 회사는 그 구체적 사항을 웹페이지 공지사항 및 앱의 공지사항 메뉴를 통해 공지합니다.</li>
          </ol>
        </div>
        <p class="tp-tit02" id="tp-spec1-16">제 16 조 (선불전자지급수단의 소멸시효 및 유효기간)</p>
        <div class="tp-cont">
          <ol class="ol-list">
            <li>①	이용자가 대가를 지불하고 구매(충전)한 선불전자지급수단은 발행일로부터 5년의 소멸시효 내에서만 회사가 발행한 선불전자지급수단을 사용할 수 있습니다. 다만, 회사가 자발적으로 선불전자지급수단의 사용을 허락한 경우에는 소멸시효를 적용하지 아니합니다.</li>
            <li>②	회사는 회사가 발행하는 선불전자지급수단의 유효기간을 각 상품별로 개별 설정할 수 있으며, 회사가 선불전자지급수단의 유효기간을 별도로 정하지 아니한 경우 제1항에서 정한 소멸시효 기간을 유효기간으로 봅니다. 다만, 회사와 고객사 간 선택적 복지제도 위탁운영 계약에 따라 부여하는 복지포인트와 고객사 또는 구매자와의 개별 약정으로 발행하는 선불전자지급수단(신유형 상품권, 충전형 포인트 등)의 경우 개별 약정으로 정하는 소멸시효 및 유효기간이 본 약관에 우선하여 적용됩니다. </li>
            <li>③	회사는 복지포인트 등 무상 선불전자지급수단 외에 유상 선불전자지급수단에 한하여도 유효기간이 도래하기 전 이메일, 문자메시지, 알림톡 등을 통해 소멸예정인 선불전자지급수단에 대해 안내합니다.</li>
            <li>④	이용자는 선불전자지급수단에 대하여 회사에 유효기간 내에 유효기간의 연장을 요청할 수 있고, 요청을 받은 회사는 특별한 사유가 없는 한 유효기간을 연장합니다. 이 경우 연장된 유효기간은 원래 유효기간 만료일로부터 기산합니다.</li>
            <li>⑤	회사는 유효기간이 도래하기 30일 전 통지를 포함하여 3회 이상 이용자에게 유효기간의 도래, 유효기간의 연장 가능 여부와 방법, 유효기간 경과 후 소멸시효 완성 전 잔액을 제15조 6항에서 정한 바와 같이 반환받을 수 있다는 내용 등을 이메일 또는 문자메시지, 알림톡 등의 방법으로 통지하여야 합니다. </li>
            <li>⑥ 본 조에도 불구하고 회사가 구매자 또는 고객사와의 개별 약정을 통해 이용자에게 제공한 선불전자지급수단의 유효기간 및 소멸시효는 구매자 또는 고객사와의 개별 약정이 가장 우선합니다.</li>
            <li>⑦	회사는 이용자가 구매한 유상 선불전자지급수단에 한하여 소멸시효 만료 1년 전 안내를 포함하여 3회 이상 이용자에게 소멸시효의 도래, 소멸시효 완성 전 잔액의 반환 가능 여부 및 방법 등에 관한 사항을 이메일 또는 문자메시지, 알림톡 등의 방법으로 통지하여야 합니다.</li>
          </ol>
        </div>
        <p class="tp-tit02" id="tp-spec1-17">제 17 조 (선불충전금의 보호 및 지급)</p>
        <div class="tp-cont">
          <ol class="ol-list">
            <li>①	회사는 이용자의 선불충전금 100분의 100 이상의 금액을 은행 등 선불충전금관리기관을 통하여 다음 각 호의 어느 하나에 해당하는 방법으로 별도 관리하여야 합니다.
              <ol class="ol-list pl11">
                <li>1. 신탁</li>
                <li>2. 예치</li>
                <li>3. 이용자를 피보험자로 하는 지급보증보험</li>
              </ol>
            </li>
            <li>②	회사가 제1항에 따라 별도 관리하는 선불충전금은 이용자의 재산이며, 선불충전금에 관한 청구권을 가지는 이용자는 회사가 선불충전금으로 별도 관리하는 재산에 대하여 다른 채권자보다 우선하여 변제 받을 권리가 있습니다.</li>
            <li>③	회사는 다음 각 호의 어느 하나에 해당하는 경우, 선불충전금관리기관에게 즉시 그 사실을 통지하고, 이용자의 청구에 따라 선불충전금관리기관을 통하여 이용자에게 선불충전금을 우선 지급하여야 합니다. 이 경우 회사는 선불충전금관리기관과 협의하여 다음 각 호의 사유가 발생한 날부터 1개월 이내에 선불충전금의 지급사유, 지급시기, 지급방법, 그 밖에 선불충전금의 지급과 관련된 사항을 둘 이상의 일간신문에 공고하고 회사의 홈페이지(www.hyundaiezwel.com)의 공지사항을 통하여 게시하여야 합니다.
              <ol class="ol-list pl11">
                <li>1. 허가 또는 등록이 취소되거나 말소된 경우</li>
                <li>2. 해산의 결의를 한 경우</li>
                <li>3. 파산선고를 받은 경우</li>
                <li>4.「전자금융거래법」 제43조 제2항에 따라 선불전자지급수단 발행 및 관리 업무 전부의 정지명령을 받은 경우</li>
                <li>5. 제1호부터 제4호까지에 준하는 사유가 발생한 경우</li>
              </ol>
            </li>
            <li>④	이용자는 별도 관리하는 선불충전금을 제3항에 따라 지급 청구하려는 경우, 다음 각 호의 사항을 기재한 서면을 선불충전금관리기관에 제출해야 합니다.
              <ol class="ol-list pl11">
                <li>1. 이용자 또는 선불전자지급수단을 식별할 수 있는 정보</li>
                <li>2. 선불충전금을 지급받을 계좌에 관한 정보</li>
              </ol>
            </li>
            <li>⑤	 제3항에 따라 이용자에게 선불충전금을 지급하여야 하는 경우, 회사는 해당 이용자에 관한 다음 각 호의 정보를 선불충전금관리기관에게 제공할 수 있습니다.
              <ol class="ol-list pl11">
                <li>1. 이용자 식별 정보</li>
                <li>2. 이용자에게 지급하여야 할 선불충전금에 관한 정보</li>
                <li>3. 선불전자지급수단 식별 정보(「금융실명거래 및 비밀보장에 관한 법률」 제2조 제4호에 따른 실지명의가 확인되지 않는 등의 사유로 이용자를 식별할 수 없는 선불전자지급수단의 경우로 한정합니다)</li>
                <li>4. 그 밖에 선불충전금 지급에 필요한 정보</li>
              </ol>
            </li>
          </ol>
        </div>
        <p class="tp-tit02" id="tp-spec1-18">제 18 조 (선불충전금 보호조치의 고지 및 게시)</p>
        <div class="tp-cont">
          <ol class="ol-list">
            <li>①	① 회사는 이용자와 선불전자지급수단에 관한 계약 체결 시, 선불충전금 보호조치에 관한 다음 각 호의 사항을 이용자에게 고지합니다.
              <ol class="ol-list pl11">
                <li>1. 선불충전금의 별도 관리 방법</li>
                <li>2. 선불충전금관리기관의 명칭 등 선불충전금관리기관에 관한 정보</li>
                <li>3. 본 약관 제18조 제3항에 따른 선불충전금 지급사유, 이용자의 청구 방법 등 선불충전금 지급절차에 관한 사항</li>
              </ol>
            </li>
            <li>②	회사는 제1항에 따른 선불충전금 보호조치의 내용을 인터넷 홈페이지에 항상 게시하여야 하고, 그 고지 내용의 세부사항 변경 시, 즉시 게시된 고지 내용을 변경합니다.</li>
          </ol>
        </div>
        <p class="tp-tit02" id="tp-spec1-19">제 19 조 (이용자 정보에 대한 비밀보장)</p>
        <div class="tp-cont">
          <ol class="ol-list">
            <li>①	회사는 관계법령에서 정한 경우를 제외하고는 전자금융거래를 수행함에 있어 알게 된 다음 각 호의 어느 하나에 해당하는 이용자 정보를 이용자의 동의를 얻지 아니하고 타인에게 제공하거나 업무상 목적 외에 사용하지 아니합니다.
              <ol class="ol-list pl11">
                <li>1. 이용자의 인적사항</li>
                <li>2. 이용자의 계좌, 접근매체 및 전자금융거래의 내용과 실적에 관한 정보 또는 자료</li>
              </ol>
            </li>
            <li>②	회사는 이용자가 안전하게 전자금융거래서비스를 이용할 수 있도록 「개인정보 보호법」, 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」 등 관계법령이 정하는 바에 따라 이용자의 개인정보를 보호하기 위해 노력합니다. 개인정보의 보호 및 사용에 대해서는 관련법 및 회사의 개인정보처리방침이 적용됩니다. 다만, 회사가 운영하는 서비스 페이지 이외의 연결(링크)된 사이트에서는 회사의 개인정보처리방침이 적용되지 않습니다.</li>
          </ol>
        </div>
        <p class="tp-tit02" id="tp-spec1-20">제 20 조 (분쟁처리 및 분쟁조정)</p>
        <div class="tp-cont">
          <ol class="ol-list">
            <li>①	이용자는 전자금융거래의 처리에 관하여 이의가 있을 때에는 회사에 손해배상 등 분쟁처리를 요구하거나 금융감독원의 금융분쟁조정위원회 또는 한국소비자원의 소비자분쟁조정위원회를 통해 분쟁 조정을 신청할 수 있습니다.</li>
            <li>②	회사는 손해배상 등 분쟁처리를 위한 분쟁처리책임자 및 담당자를 지정하며, 그 연락처(전화번호, 모사전송번호, 전자우편주소 등을 말합니다)를 인터넷 홈페이지(<NuxtLink to="www.hyundaiezwel.com" class="inline-block" target="_blank" rel="noopenner noreferrer">www.hyundaiezwel.com</NuxtLink>)를 통하여 이용자에게 알립니다.</li>
            <li>③	제1항에 따라 이용자가 회사에 손해배상 등 분쟁처리를 신청한 경우, 회사는 15일 이내에 이에 대한 조사 또는 처리결과를 이용자에게 통보합니다.</li>  
          </ol>
        </div>
        <p class="tp-tit02" id="tp-spec1-21">제 21 조 (약관적용의 우선순위 등)</p>
        <div class="tp-cont">
          <ol class="ol-list">
            <li>①	전자금융거래에 관해서는 본 약관을 우선 적용하며, 본 약관에서 정하지 않은 사항은 개별약관 및 전자금융거래법 등 관계법령이 정하는 바에 따릅니다.</li>
            <li>②	회사와 이용자 간에 개별적으로 합의한 사항이 본 약관에서 정한 사항과 다를 때에는 그 합의사항을 본 약관에 우선하여 적용합니다.</li>
          </ol>
        </div>
        <p class="tp-tit02" id="tp-spec1-22">제 22 조 (거래의 제한)</p>
        <div class="tp-cont">
          <ol class="ol-list">
            <li>①	회사는 다음 각 호의 1에 해당하는 경우에는 전자금융거래의 해당 지시에 따른 거래를 제한할 수 있습니다.
              <ol class="ol-list pl11">
                <li>1. 이용자가 접근매체에 의한 본인확인 외에 회사가 제공하는 추가적인 보안 조치를 이용하지 아니할 때</li>
                <li>2. 압류, 가압류, 가처분 등 법적 지급제한 및 관계법령 위반 등으로 거래제공이 부적합하다고 회사가 인정했을 때</li>
              </ol>  
            </li>
            <li>②	회사가 전자금융거래를 제한한 경우에는 이용자의 거래지시가 있을 때 해당 전자적 장치를 통하여 그 사유를 알려야 합니다.</li>
          </ol>
        </div>
        <p class="tp-tit02" id="tp-spec1-23">제 23 조 (준거법 등)</p>
        <div class="tp-cont">
          <ol class="ol-list">
            <li>①	본 약관의 해석 및 적용에 관하여는 대한민국법을 적용합니다.</li>
            <li>②	본 약관에 의한 거래와 관련하여 발생한 분쟁에 대하여 회사와 이용자 사이에 소송의 필요가 생긴 경우에 그 관할법원은 민사소송법에서 정한 바에 따릅니다.</li>
          </ol>
        </div>
        <p class="tp-tit02">부  칙</p>
        <div class="tp-cont">
          <ol class="ol-list">
            <li>① 본 약관은 2026년   6월   1일부터 시행합니다.</li>
          </ol>
        </div>
      </div>        
    </div>
  </div>
</template>
  
<script setup lang="ts">
import { ref, onUnmounted, nextTick } from 'vue';

const props = defineProps({
  isTermsPopupOpen: {
    type: Boolean
  }
})

const isSticky = ref(false)
const isExpanded = ref(false)
const stickySentinel = ref<HTMLElement | null>(null)

let observer: IntersectionObserver | null = null

const resetBeforeMove = async () => {
  isExpanded.value = false
  await nextTick()

  const listEl = document.querySelector('.popup-body .terms-privacy-list') as HTMLElement
  if (listEl) {
    listEl.scrollTo({ top: 0 })
  }
}

const initObserver = () => {
  if (observer) observer.disconnect()

  const scrollEl = document.querySelector('.popup-body') as HTMLElement
  if (!scrollEl || !stickySentinel.value) return

  observer = new IntersectionObserver(
    ([entry]) => {
      isSticky.value = !entry.isIntersecting

      if (entry.isIntersecting) {
        isExpanded.value = false

        const listEl = document.querySelector('.popup-body .terms-privacy-list') as HTMLElement
        if (listEl) {
          listEl.scrollTo({ top: 0 })
        }
      }
    },
    {
      root: scrollEl,
      threshold: 0,
      rootMargin: '10px 0px 0px 0px'
    }
  )

  observer.observe(stickySentinel.value)
}

watch(() => props.isTermsPopupOpen, async (newVal) => {
  if (newVal) {
    await nextTick()
    setTimeout(() => {
      initObserver()
    }, 100)
  } else {
    isSticky.value = false
    isExpanded.value = false
    if (observer) observer.disconnect()
  }
}, {immediate:true})

onUnmounted(() => {
  if (observer) observer.disconnect()
})

</script>
<style lang="scss" scoped>
</style>